// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"204":"8e006aaa","319":"9a509034","582":"f3731710","671":"31cc1b79"}[chunkId] + ".css";
};